import { useEffect, useState } from "react";
import styled from "styled-components";
import DOMPurify from "dompurify";
import { gnbConst } from "../../constants/gnbConst";
import { BoxButtonTitle, CommonFooter, ContentBox, DetailInfoBox, FlexColBetweenBox } from "../../style/common";
import ContentBtns from "./ContentBtns";
import { delContents, getContents } from "../../api/contents";
import { useNavigatePage } from "../../hooks/useNavigatePage";
import { dateHyphen } from "../../utils/dateFormChange";
import { useAlertStore } from "../../store/alertStore";
import { useParams } from "react-router-dom";

interface ContentProps {
  useIdx: string;
}

export default function Content({ useIdx }: ContentProps) {
  const { idx } = useParams<{ idx: string }>();
  const pageTitle = gnbConst[2].title;
  const setAlert = useAlertStore((state) => state.setAlert);
  const { onMovementPage } = useNavigatePage();
  const [noticeData, setNoticeData] = useState<ContentGetApiResponse>();
  const [content, setContent] = useState("");

  useEffect(() => {
    const getNotice = async () => {
      try {
        const response = await getContents({ idx: useIdx }, "notice");
        if (response.statusCode === 200) {
          setNoticeData(response);
          const contentHtml = response.data.content?.replaceAll("></p>", ">&nbsp;</p>");
          setContent(DOMPurify.sanitize(contentHtml || "입력한 내용이 없습니다."));
        } else {
          alert("공지사항을 불러오는데 실패했습니다.");
          onMovementPage(-1);
        }
      } catch (error) { }
    };

    getNotice();
  }, [useIdx]);

  const onDelClick = async () => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("복구가 불가능합니다. 정말 삭제하시겠습니까?")) {
      console.log(useIdx);
      const response = await delContents({ idx: useIdx }, "notice");

      if (response.statusCode === 200) {
        setAlert("삭제되었습니다.", "green");
        onMovementPage(-1);
      } else {
        setAlert(response.message[0], "red");
      }
    }
  }

  return (
    <FlexColBetweenBox>
      <div>
        <BoxButtonTitle>
          {pageTitle}
          <ContentBtns onClick={onDelClick} idx={idx} />
        </BoxButtonTitle>

        {noticeData && (
          <>
            <ContentTitle>{noticeData.data.title}</ContentTitle>
            <DetailInfoBox>
              <div>이름</div>
              <div>{noticeData.data.member?.member_name ? noticeData.data.member.member_name : "-"}</div>
              <div>날짜</div>
              <div>{noticeData.data.date_update ? dateHyphen(noticeData.data.date_update, "YYYY-MM-DD") : "-"}</div>
              <div>조회수</div>
              <div>{noticeData.data.count_read ? noticeData.data.count_read : "0"}</div>
            </DetailInfoBox>

            <ContentBox
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(content),
              }}
            ></ContentBox>

            <FileBox>

            </FileBox>
          </>
        )}
      </div>

      <CommonFooter>
        <div></div>
        <ContentBtns onClick={onDelClick} idx={idx} />
      </CommonFooter>
    </FlexColBetweenBox>
  );
}

const ContentTitle = styled.h4`
  color: #263439;
  font-size: 0.875rem;
  font-weight: 400;
  margin-bottom: 1rem;
`;

const FileBox = styled.div`
  
`;